import PropTypes from 'prop-types';
import Colors from "../../../config/colors";
import styles from './Label.module.scss';

const Label = (props) => {
	const labelBackground = props?.labelColor && props?.labelColor.length ? props?.labelColor : `${Colors.Black40}`;
	return (
		<label
			className={`${styles.label} ${styles.label}-${props.type} ${props.className}`}
			style={{ backgroundColor: labelBackground }}
		>
			{props.text}
		</label>
	);
};

export default Label;

Label.propTypes = {
	text: PropTypes.string,
	type: PropTypes.string,
	className: PropTypes.string,
};
